import { CoObjectItem, DimensionDetails, SheetForm } from "../../interfaces/CoObject";
import CoObjectSourceTablePanel from "../co-table-panel/CoObjectSourceTablePanel";
import { CoObjectSourceDropDownPanel } from "../co-dropdown-panel/CoObjectSourceDropDownPanel";
import { CoObjectSourceAmountPanel } from "../co-amount-panel/CoObjectSourceAmountPanel";
import { CoObjectSourceDimensionAttributePanel } from "../CoObjectSourceDimensionAttributePanel";
import { CoObjectSourceTextPanel } from "../tgk-text/CoObjectSourceTextPanel";
import React, { Dispatch, SetStateAction } from "react";
import { ObjectPanelTabs } from "./ObjectPanelComponent";
import { DatasetField } from "../../../api/models/dataset-field";
import { ReferringScenarios } from "../../../api/models/ReferringScenarios";
import { AvailableDimensions } from "./ObjectPanelComponentHook";

interface SourcePanelContainerProps {
  isEdit: boolean;
  isLocked: boolean;
  isComponentInstance: boolean;
  objectType: string;
  selectedKey: number;
  updateObjectSource: (obj, tabValid, modified) => void;
  objectSource: any;
  tab: ObjectPanelTabs;
  inheritableParameters?: DimensionDetails[] | undefined;
  datasetFields?: DatasetField[] | undefined;
  documentId: string;
  isFileExcelExisting?: boolean;
  fileExcelName?: string;
  updateFileExcelName?: (fileExcelName: string) => void;
  onPasteSmartObject: (smartObject: CoObjectItem) => void;
  originalSheetArea?: SheetForm;
  setOriginalSheetArea?: Dispatch<SetStateAction<SheetForm>>;
  setIsOldSheetOrAreaSelected?: Dispatch<SetStateAction<boolean>>;
  setIsLoadingSheetAndArea?: Dispatch<SetStateAction<boolean>>;
  setIsSheetChartAndAreaToHide?: Dispatch<SetStateAction<boolean>>;
  isSheetChartAndAreaToHide?: boolean;
  objectSourceImage?: string;
  referringScenarios: ReferringScenarios;
  availableDimensionsMetadata: AvailableDimensions;
}

export const SourcePanelContainer = (props: SourcePanelContainerProps) => {
  const {
    isEdit,
    isLocked,
    isComponentInstance,
    selectedKey,
    objectType,
    objectSource,
    updateObjectSource,
    tab,
    inheritableParameters,
    datasetFields,
    documentId,
    isFileExcelExisting,
    fileExcelName,
    updateFileExcelName,
    originalSheetArea,
    setOriginalSheetArea,
  } = props;
  if ((!isEdit || objectSource) && selectedKey == 1) {
    switch (objectType) {
      case "CHART":
      case "TABLE":
        return (
          <CoObjectSourceTablePanel
            tab={tab}
            isEdit={isEdit}
            isLocked={isLocked}
            isComponentInstance={isComponentInstance}
            updateCoObjectSourceTable={
              (obj, tabValid, modified) => updateObjectSource(obj, tabValid, modified && isEdit) // modified && isEdit otherwise override toggles are resetted
            }
            objectSource={objectSource}
            tableType={objectType}
            isFileExcelExisting={isFileExcelExisting}
            fileExcelName={fileExcelName}
            updateFileExcelName={updateFileExcelName}
            onPasteObject={props.onPasteSmartObject}
            originalSheetArea={originalSheetArea}
            setOriginalSheetArea={setOriginalSheetArea}
            setIsOldSheetOrAreaSelected={props.setIsOldSheetOrAreaSelected}
            setIsLoadingSheetAndArea={props.setIsLoadingSheetAndArea}
            setIsSheetChartAndAreaToHide={props.setIsSheetChartAndAreaToHide}
            isSheetChartAndAreaToHide={props.isSheetChartAndAreaToHide}
            objectSourceImage={objectSource?.elabResultType}
          />
        );
      case "DROPDOWN_LIST":
        return (
          <CoObjectSourceDropDownPanel
            tab={tab}
            isEdit={isEdit}
            isLocked={isLocked}
            updateCoObjectSourceDropDown={(obj, tabValid, modified) => updateObjectSource(obj, tabValid, modified)}
            objectSource={objectSource}
          />
        );
      case "AMOUNT":
        return (
          <CoObjectSourceAmountPanel
            tab={tab}
            isEdit={isEdit}
            isLocked={isLocked}
            isComponentInstance={isComponentInstance}
            updateCoObjectSourceAmount={(obj, tabValid, modified) => updateObjectSource(obj, tabValid, modified)}
            objectSource={objectSource}
            inheritableParameters={inheritableParameters}
            isFileExcelExisting={isFileExcelExisting}
            fileExcelName={fileExcelName}
            updateFileExcelName={updateFileExcelName}
            datasetFields={datasetFields}
            originalSheetArea={originalSheetArea}
            setOriginalSheetArea={setOriginalSheetArea}
            setIsOldSheetOrAreaSelected={props.setIsOldSheetOrAreaSelected}
            setIsLoadingSheetAndArea={props.setIsLoadingSheetAndArea}
            setIsSheetChartAndAreaToHide={props.setIsSheetChartAndAreaToHide}
            isSheetChartAndAreaToHide={props.isSheetChartAndAreaToHide}
            referringScenarios={props.referringScenarios}
            availableDimensionsMetadata={props.availableDimensionsMetadata}
          />
        );
      case "DIMENSION_ATTRIBUTE":
        return (
          <CoObjectSourceDimensionAttributePanel
            tab={tab}
            isEdit={isEdit}
            isLocked={isLocked}
            isComponentInstance={isComponentInstance}
            updateCoObjectSourceDimensionAttribute={(obj, tabValid, modified) =>
              updateObjectSource(obj, tabValid, modified)
            }
            objectSource={objectSource}
            inheritableParameters={inheritableParameters}
            documentId={documentId}
            referringScenarios={props.referringScenarios}
            availableDimensionsMetadata={props.availableDimensionsMetadata}
          />
        );
      case "TGK_TEXT":
        return (
          <CoObjectSourceTextPanel
            tab={tab}
            isEdit={isEdit}
            isLocked={isLocked}
            isComponentInstance={isComponentInstance}
            updateCoObjectSourceText={(obj, tabValid, modified) => updateObjectSource(obj, tabValid, modified)}
            objectSource={objectSource}
            datasetFields={datasetFields}
          />
        );
    }
  }
  return <></>;
};
